export default {
  JURY_PROFESSOR_EXAMLIST: '/jury/correct/professor/exam/list',       // 评委考试查询接口（模糊搜索框）

  JURY_EXAM_CORRECTLIST: '/jury/correct/exam/correctList',       // 考试批改列表接口

  JURY_PAPER_CORRECTLIST: '/jury/correct/paper/correctList', // 试卷批改列表接口

  JURY_SUBMIT_CORRECT: '/jury/correct/submit/correct', // 提交批改接口
  
  JURY_CORRECT_DETAIL: '/jury/correct/correctDetail' // 批改详情接口
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/correcting.js